"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const baseSelect_1 = __importDefault(require("./baseSelect"));
const option_1 = __importDefault(require("./option"));
require("@hotmart/cosmos/dist/dropdown");
require("@hotmart/cosmos/dist/select");
const GroupedSelect = ({ options, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(baseSelect_1.default, { labelClassName: "_mt-0", className: "_m-0", ...rest, children: ({ getOptionOptionalProps }) => options === null || options === void 0 ? void 0 : options.map((group) => ((0, jsx_runtime_1.jsx)("hot-select-group", { text: group.label, children: group.options.map((option) => ((0, jsx_runtime_1.jsx)(option_1.default, { ...option, ...getOptionOptionalProps(option) }, option.value))) }, group.label))) }));
};
exports.default = GroupedSelect;
